var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85177 4.27778H3.91659C3.36405 4.27778 2.83415 4.49727 2.44345 4.88797C2.05275 5.27867 1.83325 5.80858 1.83325 6.36111V16.0833C1.83325 16.6359 2.05275 17.1658 2.44345 17.5565C2.83415 17.9472 3.36405 18.1667 3.91659 18.1667H13.6388C14.1913 18.1667 14.7212 17.9472 15.1119 17.5565C15.5026 17.1658 15.7221 16.6359 15.7221 16.0833V12.1481M7.59251 12.4074L17.4999 2.5M17.4999 2.5H12.6388M17.4999 2.5V7.36111",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaunch);
export default __webpack_public_path__ + "static/media/icon_launch.27e9fd75822e5dc8ef1668297b88b466.svg";
export { ForwardRef as ReactComponent };